import { useCallback, useState } from 'react';
import apiClient from '@app/network/apiClient';
import Lang from '@lang/en';
import { healthCheckSettingsSwissOTPUrl } from '@app/definition/API';
import { CustomErrorCallInterface } from '@app/common/form/getErrorMessage';
import showNotification from '@root/src/app/designSystem/toastNotification/selectToast';

const useRefreshOTP = (): {
  refreshOTP: (otp: string) => Promise<void>;
  error: string | null;
  isRefreshed: boolean;
  setError: (value: string) => void;
} => {
  const [error, setError] = useState('');
  const [isRefreshed, setIsRefreshed] = useState(false);

  const refreshOTP = useCallback(async (otp: string) => {
    setError('');
    setIsRefreshed(false);

    try {
      const response = await apiClient.post(healthCheckSettingsSwissOTPUrl, {
        otp,
      });

      if (response.status >= 400) {
        const error = new Error(Lang.invalidResponse);
        (error as CustomErrorCallInterface).response = response.data;
        throw error;
      }
      showNotification({
        text: Lang.healthCheckRefreshOTPSuccessful,
        type: 'success',
      });

      setIsRefreshed(true);
    } catch (err: unknown) {
      const castedError = err as CustomErrorCallInterface;
      const errorMessage = castedError.response.message;
      setError(errorMessage);
    }
  }, []);

  return { refreshOTP, error, isRefreshed, setError };
};

export default useRefreshOTP;
